<template>
    <select class="form-control" name="type" id="type" @change="onChange($event)">
        <option value=''>Selecciona el tipo notificación</option>
        <option v-for="type in options" :key="type" :value="type" :selected="selectedValue == type" >{{ type }}</option>
    </select>
</template>

<script>
    export default {
        name: 'type-selector',
        props: {
            selectedValue : {
                type: String
            }
        },
        data () {
            return {
                value : '',
                options : [],
            };
        },
        methods: {
            onChange(event) {
                this.value = event.target.value;
                this.$emit('update', this.value);
            },
            initTypes () {
                this.options = ['info', 'warning', 'danger', 'success'];
            },
        },
        created () {
            this.initTypes ();
        }
    }
</script>